module.exports = __webpack_public_path__ + "static/img/5.9170559.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/sp/5.png
// module id = St5A
// module chunks = 0